import Contrat from '@/generated/classes/Contrat';
import { type ControleSignatureMasseManque } from '@/extend/classes/ResultatContratMasse';
import { ControleSignatureMasseManqueCodes } from '@/generated/classes/ResultatContratMasse';
import { type EtapeControle, type Manque, type SourceControle } from '@/custom/helpers/signatureMasse';

// Étape « document » de l'envoi en signature en masse (OVA-5011) : rubriques du contrat restées vides,
// côté employeur et côté salarié.
//
// Un contrat dont le document n'est pas complet ne part pas en signature, et l'utilisateur doit le
// savoir avant de confirmer (arbitrage OVA-5057 §1). Le serveur en décide (`controleSignatureMasse`,
// manques EMPLOYEUR_INCOMPLET et SALARIE_INCOMPLET) avec les règles de l'envoi unitaire, en rendant le
// document si besoin. Rien à compléter dans le parcours : ces rubriques se renseignent dans la
// visionneuse du contrat, par l'employeur, ou par le salarié pour les siennes.
//
// Placée après le modèle et l'objet : le rendu dépend du modèle, et le contrôle ne porte alors que sur
// les contrats qu'aucune étape précédente n'a écartés.

export const MANQUE_EMPLOYEUR_INCOMPLET = ControleSignatureMasseManqueCodes.EMPLOYEUR_INCOMPLET;
export const MANQUE_SALARIE_INCOMPLET = ControleSignatureMasseManqueCodes.SALARIE_INCOMPLET;
/**
 * Contrat sans salarié ou sans périodes de travail : conditions de `CheckContrat`, reprises par la
 * validation commune (revue de code du 15/10/2026). Le document ne peut alors pas être rendu ; ces
 * manques sont portés par cette étape, la dernière, qui écarte tout contrat dont le document ne peut pas
 * partir.
 */
export const MANQUE_SALARIE_ABSENT = ControleSignatureMasseManqueCodes.SALARIE_ABSENT;
export const MANQUE_CRENEAUX_MANQUANTS = ControleSignatureMasseManqueCodes.CRENEAUX_MANQUANTS;
const CODES_ETAPE = [MANQUE_SALARIE_ABSENT, MANQUE_CRENEAUX_MANQUANTS, MANQUE_EMPLOYEUR_INCOMPLET, MANQUE_SALARIE_INCOMPLET];

/** `source` : contrôle partagé du parcours. */
export function creerEtapeDocument(source: SourceControle): EtapeControle {
  let manquesServeur: ControleSignatureMasseManque[] = [];

  return {
    code: 'CONTRAT',

    async charger(contrats: Contrat[]): Promise<void> {
      manquesServeur = await source.manques(contrats);
    },

    controler(): Manque[] {
      return manquesServeur
        .filter((manque) => CODES_ETAPE.includes(manque.code))
        .map((manque) => ({ code: manque.code, libelle: manque.libelle, contratIds: manque.contratIds }));
    },
  };
}
